import { init } from './init';
import {
  getCurrentUser,
  getMultiFactor,
  onAuthStateChanged,
  signInWithEmail,
  verifyEmail,
  resetPassword,
  signOut,
  reauthenticateWithEmailAndPassword,
  getMultiFactorResolverWithError,
  PhoneMultiFactorGenerator,
  handlePhoneMultiFactor,
  resolvePhoneMultiFactor,
  sendVerificationCode,
  verifyCodeAndEnrollPhoneNumber,
  TotpMultiFactorGenerator,
  genTotpSecret,
  verifyCodeAndEnrollTotp,
} from './auth';

export default {
  init,
  /** auth */
  getCurrentUser,
  getMultiFactor,
  onAuthStateChanged,
  signInWithEmail,
  verifyEmail,
  resetPassword,
  signOut,
  reauthenticateWithEmailAndPassword,
  getMultiFactorResolverWithError,
  PhoneMultiFactorGenerator,
  handlePhoneMultiFactor,
  resolvePhoneMultiFactor,
  sendVerificationCode,
  verifyCodeAndEnrollPhoneNumber,
  TotpMultiFactorGenerator,
  genTotpSecret,
  verifyCodeAndEnrollTotp,
};
